import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import TextField from '../TextField';
import FilterLabel from './FilterLabel';
import { filterPropTypes } from '../../../../utility/prop_types/CriteriaPropType';

const propTypes = {
    ...filterPropTypes,
    min: PropTypes.number,
    max: PropTypes.number
};

const defaultProps = {
    min: undefined,
    max: undefined
};

function NumberFilter ({ tree, field, onChange, onClear, min, max }) {
    const classes = useStyles();
    const { properties } = tree;

    function getOperatorValue (min, max) {
        if ((Boolean(min) || min === 0) && (Boolean(max) || max === 0)) {
            return 'between';
        } else if ((Boolean(min) || min === 0) && !(Boolean(max) || max === 0)) {
            return 'greater';
        } else if (!(Boolean(min) || min === 0) && (Boolean(max) || max === 0)) {
            return 'less';
        } else {
            return '';
        }
    }

    function handleMinChange (event) {
        const operator = getOperatorValue(event.target.value, tree.properties.value1);

        if (operator === '') {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            newTree.properties = {
                ...newTree.properties,
                value0: (event.target.type === 'number' && event.target.value !== '') ? Number(event.target.value) : event.target.value,
                operator: operator
            };
            onChange(newTree);
        }
    }

    function handleMaxChange (event) {
        const operator = getOperatorValue(tree.properties.value0, event.target.value);
        if (operator === '') {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            newTree.properties = {
                ...newTree.properties,
                value1: (event.target.type === 'number' && event.target.value !== '') ? Number(event.target.value) : event.target.value,
                operator: operator
            };
            onChange(newTree);
        }
    }

    return (
        <div className={classes.root}>
            <FilterLabel field={field} />
            <TextField
                type="number"
                name="value0"
                onChange={handleMinChange}
                placeholder={field.placeholder || 'No Min'}
                value={properties.value0 != null ? properties.value0 : ''}
                error={properties.operator === 'between' && properties.value1 < properties.value0}
                inputProps={{ min: min, max: max }}
                // May need to allow input adornments in future
                // InputProps={{
                //     startAdornment: <InputAdornment position="start">£</InputAdornment>,
                // }}
            />
            <TextField
                type="number"
                name="value1"
                onChange={handleMaxChange}
                placeholder={field.placeholder || 'No Max'}
                value={properties.value1 != null ? properties.value1 : ''}
                error={properties.operator === 'between' && properties.value1 < properties.value0}
                inputProps={{ min: min, max: max }}
            />
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        '&> *:not(:last-child)': {
            marginRight: 10
        },
        '&> div': {
            flexGrow: 1
        }
    }
}));

NumberFilter.propTypes = propTypes;
NumberFilter.defaultProps = defaultProps;

export default NumberFilter;